function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 10C0 4.48 4.48 0 10 0s10 4.48 10 10-4.48 10-10 10S0 15.52 0 10zm11 4v2H9v-2h2zm-1 4c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM6 8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.283-.79 1.973-1.56 2.646C11.712 11.283 11 11.905 11 13H9c0-1.821.942-2.543 1.77-3.178C11.42 9.324 12 8.879 12 8c0-1.1-.9-2-2-2s-2 .9-2 2H6z",
  fill: "#000",
  fillOpacity: 0.54
});

var SvgIconHelpOutline = function SvgIconHelpOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "assets/icon-help_outline.b1a924cf.svg";
export { SvgIconHelpOutline as ReactComponent };